import { PurposeEnum } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { useEffect, useRef, useState } from "react";
import { useDropdownPosition } from "@/hooks/use-dropdown-position";
import SelectorComponentListItem from "@/components/searchbars/selector-component-list-item";
import { useSavedListingsStore } from "../../useSavedListingsStore";
import { IoIosArrowDown } from "react-icons/io";

export default function PurposeSelector({
  t,
  purpose,
  refetchState,
  fullWidth,
}: {
  t: any;
  purpose: PurposeEnum;
  refetchState: () => Promise<void>;
  fullWidth?: boolean;
}) {
  const [isPurposeOpen, setIsPurposeOpen] = useState(false);
  const purposeListRef = useRef<HTMLDivElement>(null);
  const setPurpose = useSavedListingsStore((state) => state.setPurpose);
  const purposeListStyles = useDropdownPosition(purposeListRef, isPurposeOpen, {
    customWidth: 180, // px,
    fullWidth: fullWidth,
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        purposeListRef.current &&
        !purposeListRef.current.contains(event.target as Node)
      ) {
        setIsPurposeOpen(false); //this will close it
      }
    };
    if (isPurposeOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPurposeOpen]);

  return (
    <div
      className={`${styles.itemWrapper} ${fullWidth ? styles.fullWidth : ""}`}
      ref={purposeListRef}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setIsPurposeOpen(!isPurposeOpen);
        }}
        className={styles.item}
      >
        <div className={styles.textWrapper}>
          <span className={styles.title}>
            {t("savedAndMyListings.purposeLabel", { default: "Purpose" })}
          </span>
          <span
            className={
              purpose !== PurposeEnum.DEFAULT ? styles.hasSelection : ""
            }
          >
            {t(purpose)}
          </span>
        </div>
        <IoIosArrowDown className={styles.dropdownIcon} />
      </button>
      {isPurposeOpen && purposeListStyles.top && (
        <ul className={`${styles.selectionList}`} style={purposeListStyles}>
          <SelectorComponentListItem
            text={t("for-sale")}
            icon={null}
            isActive={purpose === PurposeEnum.FORSALE}
            onClick={async () => {
              setPurpose(PurposeEnum.FORSALE);
              setIsPurposeOpen(false);
              await refetchState();
            }}
          />
          <SelectorComponentListItem
            text={t("for-rent")}
            icon={null}
            isActive={purpose === PurposeEnum.FORRENT}
            onClick={async () => {
              setPurpose(PurposeEnum.FORRENT);
              setIsPurposeOpen(false);
              await refetchState();
            }}
          />
          <SelectorComponentListItem
            text={t("any")}
            icon={null}
            isActive={purpose === PurposeEnum.DEFAULT}
            onClick={async () => {
              setPurpose(PurposeEnum.DEFAULT);
              setIsPurposeOpen(false);
              await refetchState();
            }}
          />
        </ul>
      )}
    </div>
  );
}
